import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ServicioProcedimientosAdmisionService, ParametrosProcedimientosAdmisionEntity,
  BodyProcedimientosAdmisionEntity, FiltrosProcedimientosAdmisionEntity,
  HeadProcedimientosAdmisionEntity} from '../../../../../services/servicio-procedimientos-admision.service';
import { SelectItem } from 'primeng/api';
import { EmpresaEntity } from 'src/app/interfaces/empresa';
import { HttpErrorResponse } from '@angular/common/http';
import { ProcedimientoEntity } from '../../../../../interfaces/procedimiento';
import { FechaService } from '../../../../../services/utils/fecha.service';
import { ServicioEntidadService, EntidadEmpresarialEntity } from '../../../../../services/servicio-entidad.service';

@Component({
  selector: 'app-header-procedimientos-admision',
  templateUrl: './header-procedimientos-admision.component.html',
  styleUrls: ['./header-procedimientos-admision.component.css']
})
export class HeaderProcedimientosAdmisionComponent implements OnInit {

  loading: boolean;
  fechaInicial: string;
  fechaFinal: string;
  mensajeError: string;

  empresaSelected: number;
  empresas: EmpresaEntity[] = [];
  empresasItem: SelectItem[] = [];

  procedimientosItem: SelectItem[] = [];
  procedimientosSelected: any[];
  procedimientos: ProcedimientoEntity[] = [];

  entidad: EntidadEmpresarialEntity;
  headData: HeadProcedimientosAdmisionEntity;
  reportData: BodyProcedimientosAdmisionEntity[];

  @Input() public objetoParametros: ParametrosProcedimientosAdmisionEntity;
  public filtros: FiltrosProcedimientosAdmisionEntity;

  @Output() emitLoading: EventEmitter<boolean>;
  @Output() emitError: EventEmitter<string>;
  @Output() emitData: EventEmitter<{ entidad: EntidadEmpresarialEntity, head: HeadProcedimientosAdmisionEntity, data: BodyProcedimientosAdmisionEntity[] }>;

  constructor(private servicioProcedimientosAdmision: ServicioProcedimientosAdmisionService,
    private servicioFecha: FechaService,
    private servicioEntidad: ServicioEntidadService) {
    this.emitLoading = new EventEmitter();
    this.emitError = new EventEmitter();
    this.emitData = new EventEmitter();
  }

  ngOnInit() {
    this.setLoading(true);
    this.getEntidadEmpresarial();
  }

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioEntidad
            .getEntidadEmpresarial(this.objetoParametros.codigoBaseDatos, Number(this.objetoParametros.uncoSede));
      if (response != null) {
        response.subscribe((data: EntidadEmpresarialEntity[]) => {
          this.entidad = data[0];
          this.getEmpresas();
        }, (err: HttpErrorResponse) => {
          this.entidad = null;
          console.error('Error getEntidadEmpresarial()', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener información de la entidad, reporte caso al administrador');
        });
      }
    } catch (e) {
      this.entidad = null;
      console.error('Error Catch getEntidadEmpresarial()', e);
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener información de la entidad, reporte caso al administrador');
    }
  }

  async getEmpresas() {
    try {
      const response = await this.servicioProcedimientosAdmision.getEmpresas(this.objetoParametros);
      if (response != null) {
        response.subscribe((data: EmpresaEntity[]) => {
          if (data && data.length > 0)  {
            this.empresas = data;
            this.empresasItem = [];
            data.forEach((e: EmpresaEntity) => {
              this.empresasItem.push({ label : e.descripcionCorta, value : e.unco });
            });
            this.empresaSelected = -1;
            this.setLoading(false);
          } else {
            this.setLoading(false);
            this.emitError.emit('<i class="fa fa-warning"></i> No fue posible obtener información de empresas en la admisión');
          }
        }, (err: HttpErrorResponse) => {
          this.empresas = [];
          this.empresasItem = [];
          console.error('Error getEmpresas()', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener empresas de la admisión, reporte caso al administrador');
        });
      }
    } catch (e) {
      console.error('Error Catch getEmpresas()', e);
      this.setLoading(false);
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener empresas de la admisión, reporte caso al administrador');
    }
  }

  async getProcedimientos(db: string, uncoAdmision: number, uncoEmpresa: number) {
    try {
      const response = await this.servicioProcedimientosAdmision.getProcedimientos(db, uncoAdmision, uncoEmpresa);
      if (response != null) {
        response.subscribe((data: ProcedimientoEntity[]) => {
          this.procedimientos = data;
          this.procedimientosItem = [];
          if (data && data.length > 0) {
            data.forEach((p: ProcedimientoEntity) => {
              this.procedimientosItem.push({ label: p.descripcionCorta, value: p.unco});
            });
            this.procedimientosSelected = [];
          }
          this.setLoading(false);
        }, (err: HttpErrorResponse) => {
          this.procedimientos = [];
          this.procedimientosItem = [];
          this.procedimientosSelected = [];
          console.error('Error getProcedimientos()', err);
          this.setLoading(false);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener empresas de la admisión, reporte caso al administrador');
        });
      }
    } catch (e) {
      this.procedimientos = [];
      this.procedimientosItem = [];
      this.procedimientosSelected = [];
      console.error('Error Catch getProcedimientos()', e);
      this.setLoading(false);
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener empresas de la admisión, reporte caso al administrador');
    }
  }

  async getData(filtros: FiltrosProcedimientosAdmisionEntity) {
    try {
      const response = await this.servicioProcedimientosAdmision.getBody(filtros);
      if (response != null) {
        response.subscribe((data: BodyProcedimientosAdmisionEntity[]) => {
          this.reportData = data;
          this.headData = this.getHeadData(data);
          this.emitData.emit({ entidad : this.entidad, head : this.headData, data });
          this.setLoading(false);
        }, (err: HttpErrorResponse) => {
          this.reportData = [];
          console.error('Error getData()', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener datos de la admisión, reporte caso al administrador');
          this.setLoading(false);
        });
      }
    } catch (e) {
      console.error('Error Catch getData()', e);
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener datos de la admisión, reporte caso al administrador');
      this.setLoading(false);
    }
  }

  // Listener

  onChangeEmpresa() {
    if (this.empresaSelected > 0) {
      this.setLoading(true);
      this.getProcedimientos(this.objetoParametros.codigoBaseDatos, Number(this.objetoParametros.uncoAdmision), this.empresaSelected);
    } else {
      this.procedimientosItem = [];
      this.procedimientosSelected = [];
      this.procedimientos = [];
    }
  }

  setLoading(value: boolean) {
    this.loading = value;
    this.emitLoading.emit(value);
  }

  onGenerar() {
    this.setLoading(true);
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);

    if (this.empresaSelected <= 0) {
      this.showMessage('<i class="fa fa-warning"></i> Recuerde que debe seleccionar una <strong>empresa</strong>');
      this.setLoading(false);
    } else if (this.procedimientosSelected.length === 0) {
      this.showMessage('<i class="fa fa-warning"></i> Recuerde que debe seleccionar al menos un <strong>procedimiento</strong>');
      this.setLoading(false);
    } else if (inicio === null || inicio.getTime() === 0) {
      this.showMessage('<i class="fa fa-warning"></i> Recuerde que debe seleccionar la <strong>Fecha Inicial</strong>');
      this.setLoading(false);
    } else if (fin === null || fin.getTime() === 0) {
      this.showMessage('<i class="fa fa-warning"></i> Recuerde que debe seleccionar la <strong>Fecha Final</strong>');
      this.setLoading(false);
    } else if (this.servicioFecha.compare(inicio, fin) === 1) {
      this.showMessage('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>');
      this.setLoading(false);
    } else {
      this.filtros = {
        codigoBaseDatos : this.objetoParametros.codigoBaseDatos,
        uncoAdmision : Number(this.objetoParametros.uncoAdmision),
        uncoEmpresa : this.empresaSelected,
        procedimientos : this.procedimientosSelected.toString(),
        fechaInicial : inicio,
        fechaFinal : fin
      };

      this.getData(this.filtros);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('admision-procedimiento-id').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
          integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );

    popupWin.document.close();
  }

  // Auxiliares

  isDisabledProcedimientos(): boolean {
    return !(this.empresaSelected && this.empresaSelected > 0) || this.loading;
  }

  isDisabledImprimir(): boolean {
    return this.loading || !this.reportData || this.reportData === null || this.reportData.length === 0;
  }

  getHeadData(data: BodyProcedimientosAdmisionEntity[]): HeadProcedimientosAdmisionEntity {
    if (data && data.length > 0) {
      const value = data[0];

      const head: HeadProcedimientosAdmisionEntity = {
        tipoDocumento : value.tipoDocumento,
        afiliado : value.afiliado,
        empresa : value.empresa,
        edad : value.edad,
        fechaAdmision : value.fechaAdmision,
        fechaNacimiento : value.fechaNacimiento,
        fechaSalidaAdmision : value.fechaSalidaAdmision,
        numeroIdentificacion : value.numeroIdentificacion,
        rangoSalarial : value.rangoSalarial,
        tipoAfiliado : value.tipoAfiliado,
        consecutivoAdmision : value.consecutivoAdmisiones,
        puntoAtencion : value.puntoAtencion,
        sede : value.sede
      };
      return head;
    }
    return null;
  }

  // Mensaje

  showMessage(error: string, life?: number) {
    this.mensajeError = error;
    const timeout = life ? life : 3500;
    setTimeout(() => {
      this.mensajeError = null;
    }, timeout);
  }

}
